import React from 'react';
import { LevelOfAssuranceField } from '@models/prediction';
import { ConfigSection } from '@components/config/ConfigSection';
import RadioButtonList, { RadioButtonEntry } from '@components/config/radioButtonsList';

export interface ConfigLevelOfAssuranceProps {
    levelOfAssuranceFieldList: LevelOfAssuranceField[];
    value?: LevelOfAssuranceField;
    onChange: (value?: LevelOfAssuranceField) => void;
}

const LevelOfAssuranceFieldSection: React.FC<ConfigLevelOfAssuranceProps> = ({
    levelOfAssuranceFieldList,
    value: selectedLevelOfAssuranceField,
    onChange,
}) => {
    const levelOfAssuranceRadioButtonList: RadioButtonEntry<LevelOfAssuranceField>[] = levelOfAssuranceFieldList.map(
        (field) => {
            return { value: field, label: field.charAt(0).toUpperCase() + field.slice(1) };
        },
    );
    const onLevelOfAssuranceChange = (element: LevelOfAssuranceField) =>
        onChange(element === selectedLevelOfAssuranceField ? undefined : element);

    return (
        <ConfigSection title="Level of Assurance" data-qa="level-of-assurance-config-section">
            <RadioButtonList
                list={levelOfAssuranceRadioButtonList}
                selectedValue={selectedLevelOfAssuranceField}
                onChange={onLevelOfAssuranceChange}
            />
        </ConfigSection>
    );
};

export default LevelOfAssuranceFieldSection;
